import classnames from 'classnames'
import React from 'react'
import { Link } from 'react-router-dom'

import useRoutes from '../../state/useRoutes'

import styles from './GroupAvatar.module.scss'
import { GroupProperties } from '../../models/BaseModels'

type AvatarProps = {
  group: GroupProperties
  omitRoleIcon?: boolean
  link?: boolean
} & React.ComponentPropsWithoutRef<'div'>

export default React.memo(function GroupAvatar({ group, link, className, ...htmlProps }: AvatarProps) {
  const routes = useRoutes()

  const src: { src?: string } = {}
  // if (group.avatarUrl) {
  //   src.src = group.avatarUrl
  // }

  const Component = link ? Link : 'div'

  return (
    <Component
      className={classnames(styles.GroupAvatar, className, {
        skeleton: group.isDummy,
      })}
      {...(htmlProps as any)}
      to={link ? routes.manageGroup.url({ uuid: group.uuid }) : undefined}
    >
      {' '}
      <img alt={`${group.name}`} data-initials={`${group.name[0].toUpperCase()}`} {...src} />
    </Component>
  )
})
